export default defineNuxtRouteMiddleware((to, from) => {
  const user = useAuthUser()
  const localePath = useLocalePath()

  if (!user.value) {
    if (from.name && from.name.startsWith("view-slug-id___")) {
      return navigateTo(localePath(`/users/login?redirect=${encodeURIComponent(to.fullPath)}&checkout`))
    } else {
      return navigateTo(localePath(`/users/login?redirect=${encodeURIComponent(to.fullPath)}`))
    }
  }
})
